import type { ReactNode } from 'react'

interface Props {
  href: string
  icon: ReactNode
  children: ReactNode
}

// white by design: lives on the fixed-dark Beta hero (BetaLayout), not app surface
export const BetaStoreButton = ({ href, icon, children }: Props) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center justify-center gap-2 h-11 rounded-xl bg-white hover:bg-white/90 text-[#0E0E12] font-medium text-sm transition-all duration-200 hover:scale-[1.02]"
  >
    {icon}
    {children}
  </a>
)
